import { themeVars as platformThemeConstants } from '../../../pdc-platform/src/ts/themes/themeConstants';

export const name: string = 'Nested Layout Container';
export const group = 'Layout';
export const moduleName: string = 'pdc-widget-layout';
export const icon: string = 'list-alt';
export const namespace: string = 'business-intelligence';
export const themeId: string = 'widget-layout';

export const themeFields = {
    makeFiltersLocal: platformThemeConstants.widgetLayoutMakeFiltersLocal,
    useGridLayoutOnMobileDevices: 'widget-layout-use-grid-on-mobile-devices'
};